import { render, staticRenderFns } from "./EtiquetaSelect.vue?vue&type=template&id=3a925067"
import script from "./EtiquetaSelect.vue?vue&type=script&lang=js"
export * from "./EtiquetaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports